'use client';

export default function LocationContent({ content }) {
  if (!content) return null;

  // Simple markdown-to-HTML renderer (mirrors BlogContent/ArticleContent pattern)
  function renderMarkdown(md) {
    const lines = md.split('\n');
    const html = [];
    let inList = false;
    let listType = '';
    let inCode = false;
    let codeLines = [];

    function closeList() {
      if (inList) {
        html.push(listType === 'ol' ? '</ol>' : '</ul>');
        inList = false;
        listType = '';
      }
    }

    function inline(text) {
      return text
        .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
        .replace(/\*(.+?)\*/g, '<em>$1</em>')
        .replace(/~~(.+?)~~/g, '<del>$1</del>')
        .replace(/`([^`]+)`/g, '<code class="bg-sky-50 text-sky-700 px-1.5 py-0.5 rounded text-sm font-mono">$1</code>')
        .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" class="text-sky-600 hover:underline font-medium" target="_blank" rel="noopener">$1</a>');
    }

    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];

      if (line.startsWith('```')) {
        if (!inCode) {
          closeList();
          inCode = true;
          codeLines = [];
        } else {
          html.push(`<pre class="bg-slate-800 text-slate-100 rounded-2xl p-5 overflow-x-auto my-6 text-sm font-mono leading-relaxed"><code>${codeLines.join('\n')}</code></pre>`);
          inCode = false;
        }
        continue;
      }

      if (inCode) { codeLines.push(line.replace(/</g, '&lt;').replace(/>/g, '&gt;')); continue; }

      if (line.startsWith('# ')) { closeList(); html.push(`<h1 class="font-display text-3xl font-bold text-slate-900 mt-10 mb-5 leading-tight">${inline(line.slice(2))}</h1>`); }
      else if (line.startsWith('## ')) { closeList(); html.push(`<h2 class="font-display text-2xl font-bold text-slate-900 mt-10 mb-4 leading-tight">${inline(line.slice(3))}</h2>`); }
      else if (line.startsWith('### ')) { closeList(); html.push(`<h3 class="font-display text-xl font-bold text-slate-800 mt-8 mb-3">${inline(line.slice(4))}</h3>`); }
      else if (line.startsWith('#### ')) { closeList(); html.push(`<h4 class="font-semibold text-slate-800 text-lg mt-6 mb-2">${inline(line.slice(5))}</h4>`); }
      else if (line.startsWith('> ')) { closeList(); html.push(`<blockquote class="border-l-4 border-sky-400 pl-5 py-1 my-6 text-slate-600 italic text-lg leading-relaxed">${inline(line.slice(2))}</blockquote>`); }
      else if (line.startsWith('---')) { closeList(); html.push('<hr class="border-slate-200 my-10" />'); }
      else if (/^\d+\.\s/.test(line)) {
        const text = line.replace(/^\d+\.\s/, '');
        if (!inList || listType !== 'ol') { closeList(); html.push('<ol class="list-decimal pl-6 my-5 space-y-2 text-slate-700">'); inList = true; listType = 'ol'; }
        html.push(`<li class="leading-relaxed">${inline(text)}</li>`);
      } else if (line.startsWith('- ') || line.startsWith('* ')) {
        const text = line.slice(2);
        if (!inList || listType !== 'ul') { closeList(); html.push('<ul class="list-disc pl-6 my-5 space-y-2 text-slate-700">'); inList = true; listType = 'ul'; }
        html.push(`<li class="leading-relaxed">${inline(text)}</li>`);
      } else if (line.trim() === '') {
        closeList();
        html.push('<div class="my-2"></div>');
      } else {
        closeList();
        html.push(`<p class="text-slate-600 leading-[1.85] my-4">${inline(line)}</p>`);
      }
    }
    closeList();
    return html.join('\n');
  }

  return (
    <article
      className="prose prose-custom prose-dropcap max-w-none"
      dangerouslySetInnerHTML={{ __html: renderMarkdown(content) }}
    />
  );
}
